module.exports = __webpack_public_path__ + "99feb35cc96e70afe1f27af90897a90e.png";